import React, { useContext } from 'react';

import { Field, FieldArray } from 'formik'
import { TextField } from 'formik-material-ui';

import {
    Grid,
    Button,
    Typography,
    Card,
    CardContent,
    CardHeader
} from '@material-ui/core';

import {
    FieldError
} from '../../../../common';

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
}));

export const ContactsForm = (props) => {
    const classes = useStyles();

    const {
        state
    } = useContext(CustomerRequestContext);

    const {
        values,
        isSavingRequest
    } = useContext(TabsContext);

    return (
        <Card>
            <CardHeader title="Contacts" />
            <CardContent>
                <FieldArray
                    name="contacts"
                    render={arrayHelpers => {
                        return (
                            <>
                                {values.contacts && values.contacts.length > 0 &&
                                    values.contacts.map((contact, index) => {
                                        return (
                                            <Grid key={index} container alignItems="center" spacing={3}>
                                                <Grid item xl={12} xs={12} md={12}>
                                                    <Typography variant="subtitle1">
                                                        {`Contact N.${index + 1}`}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xl={4} md={12} xs={12}>
                                                    <Field
                                                        className={classes.field}
                                                        variant="outlined"
                                                        key={`contacts[${index}].name`}
                                                        type="text"
                                                        name={`contacts[${index}].name`}
                                                        label="Contact name *"
                                                        disabled={props.disabled}
                                                        component={TextField}
                                                    />
                                                    <FieldError name={`contacts[${index}].name`} errors={state.errors} />
                                                </Grid>
                                                <Grid item xl={4} md={6} xs={12}>
                                                    <Field
                                                        className={classes.field}
                                                        variant="outlined"
                                                        key={`contacts[${index}].email`}
                                                        type="email"
                                                        name={`contacts[${index}].email`}
                                                        label="Email *"
                                                        disabled={props.disabled}
                                                        component={TextField}
                                                    />
                                                    <FieldError name={`contacts[${index}].email`} errors={state.errors} />
                                                </Grid>
                                                <Grid item xl={4} md={6} xs={12}>
                                                    <Field
                                                        className={classes.field}
                                                        variant="outlined"
                                                        key={`contacts[${index}].phone`}
                                                        type="phone"
                                                        name={`contacts[${index}].phone`}
                                                        label="Phone *"
                                                        disabled={props.disabled}
                                                        component={TextField}
                                                    />
                                                    <FieldError name={`contacts[${index}].phone`} errors={state.errors} />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    {index === 0
                                                        && values.contacts.length === 1
                                                        && !props.disabled && (
                                                        <Button
                                                            className={classes.addButton}
                                                            variant="contained"
                                                            color="primary"
                                                            disabled={isSavingRequest || props.disabled}
                                                            onClick={() => arrayHelpers.push({ name: "", email: "", phone: "" })}>
                                                            Add another
                                                        </Button>
                                                    )}
                                                    {index === 1 && values.contacts.length === 2 && (
                                                        <Button
                                                            className={classes.removeButton}
                                                            variant="contained"
                                                            color="secondary"
                                                            disabled={isSavingRequest || props.disabled}
                                                            onClick={() => arrayHelpers.pop()}>
                                                            Remove this
                                                        </Button>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        );
                                    })}
                            </>
                        );
                    }} />
            </CardContent>
        </Card>
    );
}